import { filesApi } from '@/api/files.api';

export async function uploadHrDocument(file: File | null | undefined): Promise<string | undefined> {
  if (!file) return undefined;
  const uploaded = await filesApi.uploadDocument(file);
  return uploaded.url ?? uploaded.fileUrl;
}

/** @deprecated Use uploadHrDocument */
export const uploadLeaveAttachment = uploadHrDocument;
